import { state } from "./State";

export const getLiveCodingTemplateCodesMap = () => state.liveCodingTemplateCodesMap;
